<template>
  <main class="main">
    <div class="homepages">
      <router-link :to="{ name: 'ordres-fabrication' }" class="homepage">
        <PhScroll />
        <span>Ordres de fabrication</span>
      </router-link>

      <router-link v-if="userStore.isAdmin" :to="{ name: 'utilisateurs' }" class="homepage">
        <PhUsersThree />
        <span>Utilisateurs</span>
      </router-link>
    </div>
  </main>
</template>

<script setup lang="ts">
import '@/assets/css/pages/_homepage.css'
import { PhScroll, PhUsersThree } from '@phosphor-icons/vue'
import { useUserStore } from '@/stores/user.ts'

const userStore = useUserStore()
</script>
